import { GoogleIcon } from "@eworkit/iris";
import React, { FC } from "react";

import { Button, IButtonProps } from "@/components/Button";
import { Flex } from "@/eworkitComponents";

import "./_google-button.scss";

interface IGoogleButtonProps extends Omit<IButtonProps, "ref"> {}

export const GoogleButton: FC<IGoogleButtonProps> = ({ children, ...buttonProps }) => {
  return (
    <Button className="google-button" size="lg" variant="secondary" display="block" {...buttonProps}>
      <Flex grow={1} innerPadding="sm" align="center" justify="center">
        <GoogleIcon size="lg" />
        {children}
      </Flex>
    </Button>
  );
};

GoogleButton.displayName = "GoogleButton";
